module.exports = __webpack_public_path__ + "assets/img/32_536_big.7a94c66f.jpg";